import { twMerge } from "tailwind-merge";
interface DividerProps {
  line?: boolean;
  className?: string;
}
export const Divider = ({ line = false, className }: DividerProps) => {
  return (
    <hr
      className={twMerge(
        "flex bg-none h-0 border-none",
        line && "bg-[#ddd] h-px",
        className
      )}
    />
  );
};
